import _get from 'lodash/get'

import {
    PROPERTY_INCOME_SAVE_ERROR,
    PROPERTY_INCOME_SAVE_SUCCESS,
    PROPERTY_INCOME_SAVING,
    PROPERTY_INCOME_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case PROPERTY_INCOME_UPDATE:
            return { ...state, ...action.propertyIncome }

        case PROPERTY_INCOME_SAVING:
            return { ...state, isSaving: true }

        case PROPERTY_INCOME_SAVE_SUCCESS:
            return {
                ...state,
                ...action.propertyIncome,
                isSaving: false,
                goToNextQuestion: true,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case PROPERTY_INCOME_SAVE_ERROR:
            return {
                ...state,
                ...action.propertyIncome,
                isSaving: false,
                goToNextQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
